"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifications = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const react_transition_group_1 = require("react-transition-group");
const Notification_1 = require("../../Notification");
require("./notifications.scss");
const iconByVariant = {
    info: 'info',
    success: 'check-mark',
    warning: 'warning',
    error: 'error',
};
const Notifications = (props) => {
    const { className, notifications = [], onDeleteNotification } = props;
    const classNames = (0, classnames_1.default)('notifications', className !== null && className !== void 0 ? className : '');
    const topLeftList = (0, react_1.useMemo)(() => notifications.filter(notification => notification.position === 'top-left')
        .map(notification => {
        var _a;
        return ({
            notification: {
                ...notification,
                data: (_a = notification.rowProps) !== null && _a !== void 0 ? _a : {
                    ...notification.data,
                    icon: iconByVariant[notification.variant],
                    modificators: [notification.variant, 'global-notification'],
                },
            },
            onClose: () => {
                onDeleteNotification(notification.id);
            },
        });
    })
        .reverse(), [notifications, onDeleteNotification]);
    const topRightList = (0, react_1.useMemo)(() => notifications.filter(notification => notification.position === 'top-right')
        .map(notification => {
        var _a;
        return ({
            notification: {
                ...notification,
                data: (_a = notification.rowProps) !== null && _a !== void 0 ? _a : {
                    ...notification.data,
                    icon: iconByVariant[notification.variant],
                    modificators: [notification.variant, 'global-notification'],
                },
            },
            onClose: () => {
                onDeleteNotification(notification.id);
            },
        });
    })
        .reverse(), [notifications, onDeleteNotification]);
    const bottomRightList = (0, react_1.useMemo)(() => notifications.filter(notification => notification.position === 'bottom-right')
        .map(notification => {
        var _a;
        return ({
            notification: {
                ...notification,
                data: (_a = notification.rowProps) !== null && _a !== void 0 ? _a : {
                    ...notification.data,
                    icon: iconByVariant[notification.variant],
                    modificators: [notification.variant, 'global-notification'],
                },
            },
            onClose: () => {
                onDeleteNotification(notification.id);
            },
        });
    })
        .reverse(), [notifications, onDeleteNotification]);
    const bottomLeftList = (0, react_1.useMemo)(() => notifications.filter(notification => notification.position === 'bottom-left')
        .map(notification => {
        var _a;
        return ({
            notification: {
                ...notification,
                data: (_a = notification.rowProps) !== null && _a !== void 0 ? _a : {
                    ...notification.data,
                    icon: iconByVariant[notification.variant],
                    modificators: [notification.variant, 'global-notification'],
                },
            },
            onClose: () => {
                onDeleteNotification(notification.id);
            },
        });
    })
        .reverse(), [notifications, onDeleteNotification]);
    // const transitionTimeouts = useRef({ enter: 500, exit: 300 });
    const topLeftRef = (0, react_1.useRef)(null);
    const topRightRef = (0, react_1.useRef)(null);
    const bottomRightRef = (0, react_1.useRef)(null);
    const bottomLeftRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: 'notifications__container notifications__container--top-left' }, topLeftList.map(item => (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: item.notification.id, classNames: 'notifications__item', timeout: 500, nodeRef: topLeftRef },
            react_1.default.createElement("div", { ref: topLeftRef },
                react_1.default.createElement(Notification_1.Notification, { onClose: item.onClose, timeout: item.notification.timeout, ...item.notification.data })))))),
        react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: 'notifications__container notifications__container--top-right' }, topRightList.map(item => (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: item.notification.id, classNames: 'notifications__item', timeout: 500, nodeRef: topRightRef },
            react_1.default.createElement("div", { ref: topRightRef },
                react_1.default.createElement(Notification_1.Notification, { timeout: item.notification.timeout, onClose: item.onClose, ...item.notification.data })))))),
        react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: 'notifications__container notifications__container--bottom-left' }, bottomLeftList.map(item => (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: item.notification.id, classNames: 'notifications__item', timeout: 500, nodeRef: bottomLeftRef },
            react_1.default.createElement("div", { ref: bottomLeftRef },
                react_1.default.createElement(Notification_1.Notification, { timeout: item.notification.timeout, onClose: item.onClose, ...item.notification.data })))))),
        react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: 'notifications__container notifications__container--bottom-right' }, bottomRightList.map(item => (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: item.notification.id, classNames: 'notifications__item', timeout: 500, nodeRef: bottomRightRef },
            react_1.default.createElement("div", { ref: bottomRightRef },
                react_1.default.createElement(Notification_1.Notification, { timeout: item.notification.timeout, onClose: item.onClose, ...item.notification.data }))))))));
};
exports.Notifications = Notifications;
//# sourceMappingURL=Notifications.js.map